import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowDown } from "lucide-react";
import CountdownTimer from "@/components/cayman/CountdownTimer";
import {
  CAYMAN_LAUNCH_DATE,
  hasLaunchDatePassed,
} from "@/utils/date-constants";

interface CaymanHeroSectionProps {
  launchPassed: boolean;
  formattedLaunchDate: string;
}

const CaymanHeroSection = ({
  launchPassed,
  formattedLaunchDate,
}: CaymanHeroSectionProps) => {
  return (
    <section className="pt-32 pb-20 px-4 bg-nation-blue-dark relative">
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/60 to-blue-900/80 backdrop-blur-[2px]"></div>

      <div className="container mx-auto relative z-10 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
              Cayman, so you've voted, <br />
              <span className="text-yellow-300">What now?</span>
            </h1>

            <p className="text-xl mb-8 opacity-90">
              NationCard™ is launching in the Cayman Islands to empower citizens
              and strengthen democracy. Together, we can hold our leaders
              accountable for a brighter future!
            </p>

            {launchPassed ? (
              <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 mb-8 border border-white/20 text-center">
                <div className="text-center mb-4">
                  <span className="text-yellow-300 font-semibold">
                    NationCard™ Cayman Islands is now LIVE!
                  </span>
                </div>
                <Button
                  size="lg"
                  variant="purple"
                  className="animate-pulse shadow-lg"
                  asChild
                >
                  <Link to="/cards/KY">Enter Platform Now</Link>
                </Button>
              </div>
            ) : (
              <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 mb-8 border border-white/20 dark:bg-gray-800/30 dark:border-gray-700/30">
                <div className="text-center mb-4">
                  <span className="text-yellow-300 font-semibold">
                    LAUNCHING IN
                  </span>
                </div>
                <CountdownTimer targetDate={CAYMAN_LAUNCH_DATE} />
              </div>
            )}

            {launchPassed ? (
              <Button
                size="lg"
                variant="purple"
                className="animate-pulse shadow-lg"
                asChild
              >
                <Link to="/cards/KY">Enter NationCard Now</Link>
              </Button>
            ) : (
              <Button
                size="lg"
                variant="purple"
                className="animate-pulse shadow-lg"
                asChild
              >
                <a href="#waitlist">Get Early Access</a>
              </Button>
            )}
          </div>

          <div className="hidden lg:block">
            <img
              src="/img/nationcard-hero1.png"
              alt="NationCard Platform Preview"
              className="rounded-lg shadow-2xl border-4 border-white/20"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/80 animate-bounce">
        <ArrowDown className="h-6 w-6" />
      </div>
    </section>
  );
};

export default CaymanHeroSection;
